/**
 * @description 导出
 * @author zhijie.huang
 * @date 2018/10/12
 * exportConfig 参数格式
    url:'/oms/inventoryOperator/queryAlloctOrders',// 查询数据的接口 根据自己页面的查询或者导出接口来配置
    method: 'POST', // 查询数据的方式
    isJson: '1', // 查询数据是否用JSON 0是非JSON数据 1是JSON数据
    currentPage: 1, // 查询数据的起始页
    loginCustomerId: '', // 查询数据的登陆者的ID
    perPageCount: 500, // 查询数据的每页条数
    // 静态字典
    staticDictionary: [
      {
        relate: 'hostType',
        type: 字典键值对
      }
    ]
    //导出的字段和表头显示，例如：
      serialNumber:'单号',  serialNumber对象的接口返回的字段，
      '单号' 显示表格的标题，
      支持对象嵌套取值 $作为层级的分隔符 operateType$value 代表取值 operateType:{value:'asdas'}
    fields:{
      serialNumber:'单号',
      operateType$value:'操作类型',
      operateDate:'操作时间'
    },
    search:{//查询接口的条件
      auditStatus:"AuditStatus@audited",
      mvnoCode:'DFGSDF',
      operateType:"OperateType@allocation"
    },
    //字典值翻译， 不需要转化可以不定义这个属性
    dictionary:[
      {
        relate: 'state',
        type: {type: 'OperateType'},
        url: '/oms/dictionary/queryDictionary'
      },
      {
        relate: 'goodsType',
        type: {type: 'OperateType'},
        url: '/oms/dictionary/queryDictionary'
      }
    ],
    time:['operateDate'], // 转化为时间 不需要转化可以不定义这个属性
    tabs:['serialNumber'], // 需要加\t制表符，用于解决导出数据科学计数法显示 不需要转化可以不定义这个属性
    string: ['applications'] // 是数组的对象，返回一个字符串
 */
'use strict'
import request from './request'
import CookieHelper from './cookieHelper'
import qs from 'qs'

const LANGUAGE = 'zh-CN'

const EXPORT_REQUEST_DEFAULT = {
  url: '/attachment/exportOps/queryProcess', // 导出接口
  method: 'POST', // 接口方式
  currentPage: 1,
  perPageCount: 10
}

class ExportTable {
  exportConfig = {
    currentPage: EXPORT_REQUEST_DEFAULT.currentPage, // 查询数据的起始页
    perPageCount: EXPORT_REQUEST_DEFAULT.perPageCount // 查询数据的每页条数
  }

  constructor (config) {
    // requestData 格式转换
    if (config.requestData) {
      this.exportConfig.url = config.requestData.url
      this.exportConfig.method = config.requestData.method.toUpperCase()
      this.exportConfig.isJson = config.requestData.json ? '1' : '0'
      if (config.requestData.auth) {
        const cookieHelper = CookieHelper.getInstance()
        this.exportConfig.loginCustomerId = cookieHelper.getCookie('loginCustomerId')
      }
    }

    if (config.dictionary && config.dictionary.length > 0) {
      config.dictionary.map(function (item) {
        if (item.type) {
          item.type.language = LANGUAGE
        }
      })
    }

    delete config.requestData
    // console.info('config', config);
    this.exportConfig = Object.assign(this.exportConfig, config)
  }

  send (success, fail) {
    const doExport = () => {
      this._send().then((data) => {
        if (data.currentPage < data.totalPageCount) {
          this.exportConfig.currentPage = data.currentPage + 1
          this.exportConfig.fileName = data.fileName
          doExport()
          success(data)
        } else {
          success(data)
        }
      }).catch(fail)
    }

    doExport()
  }

  _send () {
    // console.info('in send', this.exportConfig);
    return new Promise((resolve, reject) => {
      request({
        url: EXPORT_REQUEST_DEFAULT.url,
        data: this.exportConfig,
        method: EXPORT_REQUEST_DEFAULT.method,
        headers: {
          'Time-Zone': 'GMT' + (-new Date().getTimezoneOffset() / 60)
        },
        transformRequest: [function (data) {
          let ret = qs.stringify(data)
          return ret
        }]
      }).then((data) => {
        if (data.resultCode === '00000000') {
          // console.log(`导出第:${data.data.currentPage}份`)
          resolve({
            currentPage: data.data.currentPage,
            totalPageCount: data.data.totalPageCount,
            downUrl: data.downUrl,
            fileName: data.fileName
          })
        } else {
          reject(data)
        }
      }).catch((err) => {
        console.error('err', err)
        reject(err)
        // alert(`操作中断：${JSON.stringify(err)}`)
      })
    })
  }
}

export default ExportTable
